


















































































































































import { appConfig } from 'src/config'
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  computed: {
    ...mapState(['auth'])
  }
})
export default class Consent extends Vue {
  tos: boolean = false

  policy: boolean = false

  redirecting: boolean = false

  get client () {
    return this.$store.state.auth.consent.client
  }

  get user () {
    return this.$store.state.auth.consent.user
  }

  get challenge () {
    return this.$store.state.auth.consentChallenge
  }

  get requestedScope () {
    return this.$store.state.auth.consent.requestedScope
  }

  get validRequest () {
    return this.challenge && this.client.client_id
  }

  created () {
    if (this.$route.query.consent_challenge) {
      this.$store.commit('auth/consentChallenge', this.$route.query.consent_challenge)
    }
    if (!this.validRequest) {
      this.$router.replace('/login')
    }

  }

  meta () {
    return {
      title: `${this.$t(this.$msg.ConsentTitle)}${this.$appConfig.titlePostfix}`
    }
  }

  allowAccess () {
    if (this.client.tos_uri && !this.tos) {
      return this.$q.notify({
        color: 'negative',
        message: this.$t(this.$msg.TosRequiredError) as string,
        position: 'top'
      })
    }
    if (this.client.policy_uri && !this.policy) {
      return this.$q.notify({
        color: 'negative',
        message: this.$t(this.$msg.PolicyRequiredError) as string,
        position: 'top'
      })
    }

    const formData = {
      grantScope: this.requestedScope,
      challenge: this.challenge
    }
    const headers = {
      'CSRF-Token': this.$q.cookies.get('xsrf')
    }
    this.redirecting = true

    this.$axios.post('/consent', formData, { headers, withCredentials: true }).then(async ({ data }) => {
      if (data.redirectTo) {
        window.location.href = data.redirectTo
      } else {
        throw new Error('Redirect url is not defined.')
      }
    }).catch((error) => {
      this.redirecting = false
      throw error
    })
  }

  denyAccess () {
    const formData = {
      challenge: this.challenge,
      deny: 1
    }
    const headers = {
      'CSRF-Token': this.$q.cookies.get('xsrf')
    }
    this.redirecting = true

    this.$axios.post('/consent', formData, { headers, withCredentials: true }).then(async ({ data }) => {
      if (data.redirectTo) {
        window.location.href = data.redirectTo
      } else {
        throw new Error('Redirect url is not defined.')
      }
    }).catch((error) => {
      this.redirecting = false
      throw error
    })
  }
}
